import React, { Component } from "react";
import { TouchableOpacity,Image } from "react-native";
import TextView from "./TextView";
import { componentStyles, appStyles } from "../theme/styles";
import { blueDarkColor, blueLightColor } from "../theme/colors";
import LinearGradient from 'react-native-linear-gradient';
import { showMessageCallback } from "../utils/utils";

export default class ServiceItem extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        var item = this.props.data;
        return (
            <TouchableOpacity onPress={() => {
                if (item.ismessage === 'yes') {
                    showMessageCallback(item.title, item.textmessage, () => {
                        this.props.navigation.navigate('serviceInfo', {
                            id: item.id,
                            title: item.title
                        })
                    })
                } else {
                    this.props.navigation.navigate('serviceInfo', {
                        id: item.id,
                        title: item.title
                    })
                }

            }}>
                <LinearGradient colors={[blueLightColor, blueDarkColor]} style={componentStyles.serviceItemWraper}>
                    <Image
                        source={{ uri: item.imageurl }}
                        style={componentStyles.serviceImage} />
                    <TextView numberOfLines={2} style={{ fontSize: 12, color: 'white', textAlign: 'center', margin: 5 }}>{item.title}</TextView>
                </LinearGradient>
            </TouchableOpacity>
        );
    }
}


